import { ChannelTypeEnum, InAppProviderIdEnum } from '../../../types';
import { novuInAppConfig } from '../credentials';
export const inAppProviders = [
    {
        id: InAppProviderIdEnum.Novu,
        displayName: 'pingr-notify Inbox',
        channel: ChannelTypeEnum.IN_APP,
        credentials: novuInAppConfig,
        docReference: 'https://github.com/RainerTekOrg/pingr-notify#in-app-notifications',
        logoFileName: { light: 'pingr-notify.svg', dark: 'pingr-notify.svg' },
    },
];
//# sourceMappingURL=in-app.js.map